var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6325",
    "data-name": "Rectangle 6325",
    width: 40,
    height: 40.015,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34941",
    "data-name": "Group 34941",
    transform: "translate(-4003 -5405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4003 5405)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34873",
    "data-name": "Group 34873",
    transform: "translate(4020 5422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34872",
    "data-name": "Group 34872",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24386",
    "data-name": "Path 24386",
    d: "M40,.474V11.18c-.277.52-.794.442-1.269.457V34.823c1.013.117,1.013.117,1.269.5v4.689H.469A.77.77,0,0,1,0,39.349c0-1.276-.009-2.552,0-3.828a.632.632,0,0,1,.671-.663c.19-.011.383,0,.594,0v-23.2c-.1-.011-.172-.027-.248-.029C.147,11.6,0,11.455,0,10.6Q0,5.752,0,.909c0-.7.208-.9.911-.9Q20.006.006,39.1,0a.89.89,0,0,1,.9.474M37.4,11.661H2.61V34.837h9.011v-.475q0-5.724,0-11.447c0-.8.165-.962.958-.962H27.421c.794,0,.959.166.959.962q0,5.724,0,11.447v.47H37.4Zm1.274,24.5H1.33v2.528H38.679ZM19.336,23.256H12.922V34.837h6.414Zm7.732.009h-6.4v11.57h6.4ZM38.682,9.079H1.326V10.3H38.682ZM3.861,1.334H1.319v6.38H3.861Zm3.857,0H5.18v6.4H7.718Zm1.35,6.4H11.59V1.318H9.068Zm3.858,0h2.524v-6.4H12.927Zm6.41-6.39h-2.53V7.729h2.53Zm1.327,6.38h2.53V1.32h-2.53Zm6.415-6.383H24.545V7.718h2.535Zm1.33,6.392h2.523v-6.4H28.409Zm6.417-6.4H32.289V7.712h2.537Zm1.326,6.4h2.525v-6.4H36.152Z",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24387",
    "data-name": "Path 24387",
    d: "M11.817,19.755c0-.243-.008-.424,0-.6a.64.64,0,0,1,.681-.693q1.249-.026,2.5,0a.64.64,0,0,1,.671.7c.01.39,0,.779,0,1.2H29.878c0-.355,0-.727,0-1.1.006-.571.236-.808.806-.813.715-.007,1.432,0,2.148,0,.7,0,.892.2.9.911,0,.115.014.229.024.393.575,0,1.13,0,1.685,0,.67,0,.867.194.869.854q.006,1.718,0,3.438c0,.647-.222.865-.868.869-.556,0-1.112,0-1.72,0,0,.249.01.455,0,.659a.576.576,0,0,1-.59.6q-1.327.028-2.656,0a.592.592,0,0,1-.6-.642c-.015-.4,0-.806,0-1.242H15.674c0,.352,0,.688,0,1.024,0,.667-.2.871-.852.874q-1.074,0-2.148,0c-.66,0-.848-.2-.858-.867,0-.115,0-.23,0-.409H10.2c-.781,0-.969-.187-.971-.964,0-1.12,0-2.24,0-3.36,0-.636.206-.833.846-.837.557,0,1.115,0,1.736,0m18.05,1.958H15.7v1.231H29.867ZM13.116,24.889h1.249V19.775H13.116Zm19.322-5.1H31.192v5.1h1.247Zm-21.9,3.795h1.24V21.043h-1.24Zm23.222,0h1.245V21.053H33.761Z",
    transform: "translate(-2.775 -5.545)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6323",
    "data-name": "Rectangle 6323",
    width: 1.215,
    height: 2.537,
    transform: "translate(16.816 28.418)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6324",
    "data-name": "Rectangle 6324",
    width: 1.218,
    height: 2.532,
    transform: "translate(21.967 28.423)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.40f1e1d0e6ca5e0f9c97566db5570686.svg";
export { ForwardRef as ReactComponent };